import React from "react"
import _ from "lodash"
import SimpleLoader from "./SimpleLoader"

class Query extends React.Component {
  props: {
    query: any,
    args: any,
    children: any,
    onResponse: any,

    allEvents: boolean,
  }

  state = {
    response: undefined,
    done: false,
    error: undefined,
  }

  componentDidMount () {
    this.performQuery()
  }

  componentDidUpdate ( prevProps ) {
    if ( !_.isEqual( prevProps.args, this.props.args ) ) {
      this.performQuery()
    }
  }

  performQuery = () => {
    if ( this.props.query ) {
      this.setState( {
        response: undefined,
        error: undefined,
        done: false,
      } )
      this.props.query( this.props.args )
        .then( response => {
          if ( this.props.onResponse ) {
            this.props.onResponse( response )
          }
          this.setState( {
            response,
            done: true,
          } )
        } )
        .catch( error => this.setState( {
          error,
          done: true,
        } ) )
    }
  }

  renderChildren = () => {
    const { error, response, done } = this.state
    const loading = !done

    if ( !this.props.children.apply ) {
      return this.props.children
    } else {
      return this.props.children( {
        loading,
        error,
        response,
        done,
      } )
    }
  }

  render () {
    const { response, done } = this.state
    const loading = !done

    if ( !this.props.children ) {
      return null
    }

    // If the user has subscribed to all events, instead of just when the query is done
    // We render them every cycle
    if ( this.props.allEvents ) {
      return this.renderChildren()
    }

    // Automatically managed mode

    if ( loading ) {
      return <SimpleLoader />
    }

    if ( done && response ) {
      return this.renderChildren()
    }

    // if ( done && error ) {
    // }

    return null
  }
}

export default Query



// WEBPACK FOOTER //
// ./src/components/Query.jsx